import "./SolarScaffolding.module.css";
import Header from "@/reusable_sections/Header";
import SolarPartner from "./sections/SolarPartner";
import SolarBenefits from "./sections/SolarBenefits";
import Quote from "./sections/Quote";
import Footer from "@/reusable_sections/Footer";
export default function SolarScaffoldingPage() {
  return <div>
      <Header />
      <SolarPartner />
      <SolarBenefits />
      <Quote />
      <Footer />
    </div>;
}